// var swiper = new Swiper(".related-article", {
//     slidesPerView: 1, 
//     spaceBetween: 24,
//     navigation: {
//       nextEl: ".arrow-style-next",
//       prevEl: ".arrow-style-prev",
//     },
//     pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },
//     breakpoints: {
//       1025: {
//         slidesPerView: 3,
//       },
//        600: {
//         slidesPerView: 2.8,
//       },
//       375: {
//         slidesPerView: 1,
//       }
//     },
//     });

    // product swiper 

    var swiper = new Swiper(".related-product", {
        slidesPerView: 1, 
        spaceBetween: 24,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: ".arrow-style-next",
          prevEl: ".arrow-style-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        breakpoints: {
          1025: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 14,
          },
          450: {
            slidesPerView: 2,
            spaceBetween: 14,
          },
          375: {
            slidesPerView: 1,
          }
        },
        });


// sidebar slider 
var swiper = new Swiper(".custom-articles", {
  slidesPerView: 1,
  // loop: true,
  speed: 1000,
  grid: {
    rows: 2,
  },
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});  
